var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "lg",
      "opacity": "0.6",
      "spinner-variant": "primary"
    }
  }, [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Magazines',
        to: {
          name: _vm.MagazinePath.name
        }
      }, {
        label: 'Add New'
      }],
      "title": "New Magazine"
    }
  }), _vm.show ? _c('form', {
    staticClass: "bg-white w-full rounded-lg my-3 px-4 py-4",
    attrs: {
      "id": "form-new"
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-end"
  }, [_c('div', [_c('h4', {
    staticClass: "text-xl font-bold capitalize"
  }, [_vm._v("Create New Magazine")])])]), _c('div', {
    staticClass: "mt-3 flex justify-between"
  }, [_c('div', {
    staticClass: "w-full flex justify-between"
  }, [_c('div', {
    staticClass: "w-1/2 pr-10"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "font-semibold text-gray-600"
  }, [_vm._v("Brand")]), _c('multiselect', {
    staticClass: "w-full",
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Enter Brand",
      "open-direction": "bottom",
      "required": "required",
      "options": _vm.brandSearchOptions,
      "searchable": true,
      "loading": _vm.isBrandSearch,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": false,
      "allow-empty": false
    },
    on: {
      "search-change": _vm.brandFind,
      "select": _vm.brandSelected
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (_ref) {
        var option = _ref.option;
        return [_c('span', {
          staticClass: "tooltip-container"
        }, [_vm._v(" " + _vm._s(option.name) + " "), option.name.length > 50 ? _c('span', {
          staticClass: "tooltip"
        }, [_vm._v(_vm._s(option.name))]) : _vm._e()])];
      }
    }], null, false, 3814125221),
    model: {
      value: _vm.form.brand,
      callback: function ($$v) {
        _vm.$set(_vm.form, "brand", $$v);
      },
      expression: "form.brand"
    }
  })], 1), _c('div', {
    staticClass: "block mt-3"
  }, [_c('label', {
    staticClass: "font-semibold text-gray-600"
  }, [_vm._v("Display Name (Item’s Title)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    staticClass: "w-full bg-gray-50 rounded-lg border",
    attrs: {
      "id": "display",
      "type": "text",
      "placeholder": "Enter Display Name",
      "required": ""
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "grid gap-4 mt-3 grid-cols-2"
  }, [_c('div', [_c('label', {
    staticClass: "font-semibold text-gray-600"
  }, [_vm._v("Issue Number")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.issue_number,
      expression: "form.issue_number"
    }],
    staticClass: "w-full bg-gray-50 rounded-lg border",
    attrs: {
      "id": "issue",
      "disabled": _vm.userData.role_id === 5,
      "type": "text",
      "placeholder": "Enter Issue Number",
      "required": ""
    },
    domProps: {
      "value": _vm.form.issue_number
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "issue_number", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "font-semibold text-gray-600"
  }, [_vm._v("Edition Code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.edition_code,
      expression: "form.edition_code"
    }],
    staticClass: "w-full bg-gray-50 rounded-lg border",
    attrs: {
      "id": "code",
      "type": "text",
      "placeholder": "Enter Edition Code",
      "required": ""
    },
    domProps: {
      "value": _vm.form.edition_code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "edition_code", $event.target.value);
      }
    }
  })])]), _c('div')]), _c('div', {
    staticClass: "w-1/2 pl-10"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "font-semibold text-gray-600"
  }, [_vm._v("Languages")]), _c('multiselect', {
    attrs: {
      "placeholder": "Enter languages",
      "open-direction": "bottom",
      "label": "name",
      "track-by": "name",
      "custom-label": _vm.nameWithISO,
      "options": _vm.languagesSearchOptions,
      "searchable": true,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": true,
      "required": ""
    },
    model: {
      value: _vm.form.languages,
      callback: function ($$v) {
        _vm.$set(_vm.form, "languages", $$v);
      },
      expression: "form.languages"
    }
  })], 1), _c('div', {
    staticClass: "block mt-3"
  }, [_c('label', {
    staticClass: "font-semibold text-gray-600"
  }, [_vm._v("Countries")]), _c('multiselect', {
    attrs: {
      "placeholder": "Enter Countries",
      "open-direction": "bottom",
      "label": "name",
      "track-by": "name",
      "custom-label": _vm.nameWithISO,
      "options": _vm.countriesSearchOptions,
      "loading": _vm.isCountriesSearch,
      "searchable": true,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": true
    },
    model: {
      value: _vm.form.countries,
      callback: function ($$v) {
        _vm.$set(_vm.form, "countries", $$v);
      },
      expression: "form.countries"
    }
  })], 1), _c('div', {
    staticClass: "block mt-3"
  }, [_c('label', {
    staticClass: "font-semibold text-gray-600"
  }, [_vm._v("Categories")]), _c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Enter Categories",
      "open-direction": "bottom",
      "options": _vm.categoriesSearchOptions,
      "loading": _vm.isCategoriesSearch,
      "searchable": true,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": true
    },
    on: {
      "search-change": _vm.categoriesFind
    },
    model: {
      value: _vm.form.categories,
      callback: function ($$v) {
        _vm.$set(_vm.form, "categories", $$v);
      },
      expression: "form.categories"
    }
  })], 1)])])]), _c('h4', {
    staticClass: "text-xl font-bold capitalize block border-t w-full mt-4 pt-3"
  }, [_vm._v("Detail")]), _c('div', {
    staticClass: "justify-start flex"
  }, [_c('div', {
    staticClass: "w-1/2 pr-10"
  }, [_c('DatetimeCustom', {
    attrs: {
      "label": 'Release Date (GMT ' + _vm.timezoneString() + ')'
    },
    model: {
      value: _vm.form.release_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "release_date", $$v);
      },
      expression: "form.release_date"
    }
  }), _c('DatetimeCustom', {
    staticClass: "mt-3",
    attrs: {
      "label": 'Release Schedule (GMT ' + _vm.timezoneString() + ')'
    },
    model: {
      value: _vm.form.schedule_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "schedule_date", $$v);
      },
      expression: "form.schedule_date"
    }
  }), _c('div', {
    staticClass: "grid gap-4 grid-cols-2 mt-3"
  }, [_c('div', [_c('div', {
    staticClass: "mt-0"
  }, [_c('label', {
    staticClass: "font-semibold text-gray-600 mb-3"
  }, [_vm._v("Printed Price Currency")]), _c('t-select', {
    attrs: {
      "id": "currency",
      "options": _vm.currencys,
      "required": ""
    },
    model: {
      value: _vm.form.currency,
      callback: function ($$v) {
        _vm.$set(_vm.form, "currency", $$v);
      },
      expression: "form.currency"
    }
  })], 1), _c('div', {
    staticClass: "mt-3"
  }, [_c('label', {
    staticClass: "font-semibold text-gray-600 mb-3"
  }, [_vm._v("Content Type")]), _c('t-select', {
    staticClass: "bg-gray-50",
    attrs: {
      "id": "content_type",
      "options": _vm.contents,
      "required": ""
    },
    model: {
      value: _vm.form.content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c('div', {
    staticClass: "mt-3"
  }, [_c('label', {
    staticClass: "font-semibold mb-3 text-gray-600"
  }, [_vm._v("Distribution Countries")]), _c('t-select', {
    attrs: {
      "id": "distribution",
      "options": _vm.distributionSearchOptions,
      "disabled": "",
      "required": ""
    },
    model: {
      value: _vm.form.distribution,
      callback: function ($$v) {
        _vm.$set(_vm.form, "distribution", $$v);
      },
      expression: "form.distribution"
    }
  })], 1)]), _c('div', [_c('div', {
    staticClass: "mt-0"
  }, [_c('label', {
    staticClass: "font-semibold mb-3 text-gray-600"
  }, [_vm._v("Printed Price")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.price,
      expression: "form.price"
    }],
    staticClass: "w-full bg-gray-50 rounded-lg border",
    attrs: {
      "id": "price",
      "type": "number",
      "step": "any",
      "placeholder": "99000 (no separator)"
    },
    domProps: {
      "value": _vm.form.price
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "price", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "mt-3"
  }, [_c('label', {
    staticClass: "font-semibold mb-3 text-gray-600"
  }, [_vm._v("Parental Control")]), _c('t-select', {
    staticClass: "bg-gray-50",
    attrs: {
      "id": "parentals",
      "options": _vm.parentals,
      "required": ""
    },
    model: {
      value: _vm.form.parental,
      callback: function ($$v) {
        _vm.$set(_vm.form, "parental", $$v);
      },
      expression: "form.parental"
    }
  })], 1), _c('div', {
    staticClass: "mt-3"
  }, [_c('label', {
    staticClass: "font-semibold mb-3 text-gray-600"
  }, [_vm._v("Reading Direction")]), _c('t-select', {
    attrs: {
      "id": "readings",
      "options": _vm.readings,
      "required": ""
    },
    model: {
      value: _vm.form.reading,
      callback: function ($$v) {
        _vm.$set(_vm.form, "reading", $$v);
      },
      expression: "form.reading"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex justify-start"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('t-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.form.is_active,
      callback: function ($$v) {
        _vm.$set(_vm.form, "is_active", $$v);
      },
      expression: "form.is_active"
    }
  }), _c('label', {
    staticClass: "text-gray-600 font-semibold mt-3 ml-2"
  }, [_vm._v("Active")])], 1), !_vm.isProfileVendor ? _c('div', [!_vm.isProfileVendor ? _c('t-checkbox', {
    staticClass: "ml-2",
    attrs: {
      "id": "content",
      "options": _vm.contents,
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.form.is_internal_content,
      callback: function ($$v) {
        _vm.$set(_vm.form, "is_internal_content", $$v);
      },
      expression: "form.is_internal_content"
    }
  }) : _vm._e(), _c('label', {
    staticClass: "text-gray-600 font-semibold mt-3 ml-2"
  }, [_vm._v("Internal Content")])], 1) : _vm._e()]), _c('div', {
    staticClass: "flex justify-start mt-2"
  }, [_c('button', {
    staticClass: "bg-blue-700 p-2 px-2 text-white rounded-lg",
    attrs: {
      "type": "submit",
      "form": "form-new",
      "hidden": _vm.isLoading
    }
  }, [_vm._v(" Save ")]), _c('button', {
    staticClass: "bg-white border-blue-700 text-blue-700 border-l border-t border-b border-r rounded-lg ml-3 px-3",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset Form")]), _c('button', {
    staticClass: "bg-white p-2 px-3 text-gray-800 border rounded-lg ml-3"
  }, [_c('router-link', {
    staticClass: "text-capitalize text-gray-800 font-normal",
    attrs: {
      "to": {
        name: _vm.MagazinePath.name
      }
    }
  }, [_vm._v(" Cancel")])], 1)])], 1), _c('div', {
    staticClass: "w-1/2 pl-10"
  }, [_c('div', {
    staticClass: "block mt-3"
  }, [_c('label', {
    staticClass: "font-semibold mb-3 text-gray-600"
  }, [_vm._v("Description")]), _c('t-textarea', {
    attrs: {
      "id": "description",
      "placeholder": "Enter something...",
      "rows": "5"
    },
    model: {
      value: _vm.form.description,
      callback: function ($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1)])])]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }